'use strict';

class GroupViewCtrl {
  constructor($stateParams, LoaderSvc, moment,
    GroupSvc, GrpTypeSvc, GroupAuthSvc, GrpRoleSvc, PositionSvc
  ) {
    // Use the Group $resource to fetch all data
    var that = this;
    var groupId = $stateParams.groupId;
    this.groupId = groupId;

    GroupAuthSvc.getPermissionChecker(groupId, 'group', 'I')
      .then(function(hasGroupPerm) {
        that.hasGroupPerm = hasGroupPerm;
      });

    // pass tz as queryString param to server for active query
    var tz = moment().utcOffset();

    LoaderSvc.start();
    //load group
    GroupSvc.get({groupId: this.groupId}).$promise
      .then(function(group) {
        LoaderSvc.stop();
        that.group = group;
      })
      .catch(function() {
        LoaderSvc.stopError('Error loading group');
      });

    GrpTypeSvc.getDesc({groupId}).$promise
      .then(function(gt) {
        that.groupTypes = gt;
      });

    GrpRoleSvc.query({groupId}, function(groupRoles) {
      that.groupRoles = groupRoles;
    });

    // Group Positions
    PositionSvc.query({groupId, tz}, function(p) {
      that.positions = p;
    });
  }
}

GroupViewCtrl.$inject = [
  '$stateParams',
  'LoaderSvc',
  'moment',
  'GroupSvc',
  'GrpTypeSvc',
  'GroupAuthSvc',
  'GrpRoleSvc',
  'PositionSvc'
];

////////////////////////////////////////////////////////////////////////////////
/// TODO: Revisit controller code below
////////////////////////////////////////////////////////////////////////////////
//
// // var now = new Date(); // used to compare end date of positions
//
// // temporary altrusa: edit membership & member type only available to staff
// $scope.isStaff = false;
// var rootGrpId = angular.copy($scope.context.grp.rootGrpId);
// if(AuthSvc.getGroupRole(groupId) === 'super'
//   || AuthSvc.getGroupRole(rootGrpId) === 'super'
//   || AuthSvc.getSiteRole() === 'SITE_ADMIN'
//    // TODO:bk: not 100% sure what this last condition does (JS code)
//   || (rootGrpId && angular.equals(rootGrpId, groupId))) {
//   $scope.isStaff = true;
// }
//
//
// //////////////////////////////////////////////////////////////////////////
// ///   Members  ///////////////////////////////////////////////////////////
// //////////////////////////////////////////////////////////////////////////
// // data is required by list portlet
// function loadMembers() {
//   MemberSvc.list({groupId}, function(members) {
//     $scope.data = members;
//     loadPositions();
//   }, function(err) {
//     console.log(err);
//   });
// }
//
//
// //////////////////////////////////////////////////////////////////////////
// ///   Member Positions  //////////////////////////////////////////////////
// //////////////////////////////////////////////////////////////////////////
// $scope.groupAdmins = [];
// function loadPositionsAndRoles() {
//   var members = $scope.data;
//
//   var unsortedMembersWithPositions = [];
//   var groupAdmins = [];
//   // 'super', 'fullAdmin', 'admin', 'member'
//   var groupRoles = {
//     super: {display: 'Altrusa Staff', displayOrder: 1},
//     fullAdmin: {display: 'Full Admin', displayOrder: 2},
//     admin: {display: 'Admin', displayOrder: 3}
//   };
//
//   var m;
//   var g;
//   var p;
//
//   // iterate over members
//   for(var i = 0; i < members.length; i++) {
//     m = members[i];
//     // member's adin role in group
//     // bk > note to JS: usuually for arrays/object attributes use plural
//     if(m.user.groupRole && m.user.groupRole[groupId]) {
//       if(m.user.groupRole[groupId] !== 'member') {
//         groupAdmins.push({
//           user: m.user,
//           groupRole: groupRoles[m.user.groupRole[groupId]]
//         });
//       }
//     }
//     $scope.groupAdmins = groupAdmins;
//
//     var testEnd; // var to compare endDates on positions
//     // member's position in group
//     if(m.groups) {
//       // iterate over groups for matching group
//       for(var j = 0; j < m.groups.length; j++) {
//         g = m.groups[j];
//         // validate group matches current group
//         if(g._id === groupId) {
//           // found group - search positions now
//           j = m.groups.length;
//
//           if(g.membership && g.membership.positions) {
//             for(var k = 0; k < g.membership.positions.length; k++) {
//               p = g.membership.positions[k];
//               // check if removed, no end date, or future end date
//               testEnd = new Date(p.end);
//               if(!p.removed && (!p.end || testEnd > now)) {
//                 var position = {
//                   user: m.user,
//                   position: groupPositions[p.position]
//                 };
//                 if(p.customPosition) {
//                   position.position = {name: p.customPosition};
//                 }
//                 unsortedMembersWithPositions.push(position);
//               }
//             }
//           }
//           //iterate over positions
//         }
//       }
//
//     }
//   }
//
//   $scope.memberPositions = unsortedMembersWithPositions;
// }

export default [
  '$stateParams',
  'LoaderSvc',
  'moment',
  'GroupSvc',
  'GrpTypeSvc',
  'GroupAuthSvc',
  'GrpRoleSvc',
  'PositionSvc',
  GroupViewCtrl
];
